import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { LovValues } from '../../../models/template.model';

export interface ElementType {
  key: string;
  value: string;
  description?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LovService {
  private readonly API_URL = '/cepapi/api/lookup/ref/country';
  // Variable to store the transformed response
  private elementTypesData: ElementType[] = [];

  constructor(private http: HttpClient) {}

  loadAndStoreElementTypes(): Observable<ElementType[]> {
    return this.getPropertyElementTypes().pipe(
      tap(elementTypes => {
        this.elementTypesData = elementTypes;
      }),
      catchError(error => {
        this.elementTypesData = [];
        throw error; // Re-throw to let component handle it
      })
    );
  }
  /**
   * Get property element types
   */
  getPropertyElementTypes(): Observable<ElementType[]> {
    return this.http
      .get<any>(this.API_URL, {
        params: { lookupcategory: 'MIQ_PROPERTY_ELEMENT_TYPE' },
      })
      .pipe(
        map(response => this.transformResponse(response)),
        catchError(error => {
          return of([]);
        })
      );
  }

  /**
   * Transform API response to ElementType array
   */
  private transformResponse(response: any): ElementType[] {
    try {
      if (!response) return [];

      // Get array from response
      let dataArray: any[] = [];
      if (Array.isArray(response)) {
        dataArray = response;
      } else if (response.data && Array.isArray(response.data)) {
        dataArray = response.data;
      } else if (response.items && Array.isArray(response.items)) {
        dataArray = response.items;
      } else {
        return [];
      }

      // Transform items
      return dataArray
        .filter(item => item && typeof item === 'object')
        .map(item => ({
          key: item.key || item.code || item.id || '',
          value: item.value || item.description || item.name || '',
          description: item.description || item.desc || '',
        }))
        .filter(item => item.key && item.value);
    } catch (error) {
      return [];
    }
  }

  /**
   * Create lookup map for efficient searches
   */
  getLookupMap(): LovValues[] {
    return this.elementTypesData.map(item => ({
      key: item.key,
      value: item.value,
    }));
  }
}
